require('./accountDebitAnnulationFailure.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
const WizardError = require('components/commons/wizardError/wizardError')

class AccountDebitAnnulationFailure extends React.Component {

    buildSuccessMessage() {
        return (
            <div className="account-debits-annulation-success__message">
                <FormattedText value="annulationSuccessful-alreadyCanceled"/>
            </div>
        )
    }

	render() {
        const { accountId } = this.props;
        const title = <FormattedText value="annulationSuccessful-alreadyCanceled" />;
        const debitsLink = `/myprofile/accounts/${accountId}/debits`;
        const mainButton = {
            label: <FormattedText value="annulationSuccessful-backToDebits" />,
            url: debitsLink
        }

		return (
    <WizardError
        errorMessage={title}
        mainButton={mainButton}
    >
        <div>
            <div className="account-debits-annulation-success__message-container">

            </div>
        </div>
    </WizardError>
		)
	}
}

AccountDebitAnnulationFailure.propTypes = {
    accountId: PropTypes.string.isRequired
};

module.exports = AccountDebitAnnulationFailure;